import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

import { i18next as i18nSharedUi } from '@canvas-logic/clp-shared-ui';
import { isRtlLanguage } from '@canvas-logic/clp-api-types';

const applyDocumentLanguage = (lng: string) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = isRtlLanguage(lng) ? 'rtl' : 'ltr';
};

i18n
  .use(initReactI18next)
  .use(Backend)
  .init({
    lng: 'en',
    backend: {
      loadPath: `${window.APP_CONFIG.BASE}assets/locales/{{lng}}/{{ns}}.json`,
    },
    ns: ['pdf', 'translation'],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    applyDocumentLanguage(i18n.language || 'en');
  });

i18n.on('languageChanged', (lng) => {
  i18nSharedUi.changeLanguage(lng);
  applyDocumentLanguage(lng);
});

export default i18n;
